import { render, staticRenderFns } from "./StatefullButton.vue?vue&type=template&id=1ddace1c&scoped=true&"
import script from "./StatefullButton.vue?vue&type=script&lang=ts&"
export * from "./StatefullButton.vue?vue&type=script&lang=ts&"
import style0 from "./StatefullButton.vue?vue&type=style&index=0&id=1ddace1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddace1c",
  null
  
)

export default component.exports